import React, { useState, useEffect } from 'react';
import ReactTable from "react-table";
import Select from "react-select";

export default function ListaDetalles({ detalles, onUpdateDetalle, variablesConfig = [], searchProduct, tipoProducto }) {
  const [maestroPiezas, setMaestroPiezas] = useState([]);
  const [loadingPiezas, setLoadingPiezas] = useState(false);
  const [productosDisponibles, setProductosDisponibles] = useState([]);

  useEffect(() => {
    fetch('/api/vidrieria/productos')
      .then(res => res.json())
      .then(data => setProductosDisponibles(data))
      .catch(err => console.error(err));
  }, []);


  const varsDetectadas = variablesConfig
    .map(v => v.id || v.clave)
    .filter(v => v === "W" || v === "H"); // Add other variables here in the future

  const hasW = varsDetectadas.includes("W");
  const hasH = varsDetectadas.includes("H");

  useEffect(() => {
    if (varsDetectadas.length > 0 && tipoProducto) {
      loadMaestroPiezas(varsDetectadas, tipoProducto);
    } else {
      setMaestroPiezas([]);
    }
  }, [JSON.stringify(varsDetectadas), tipoProducto]);

  const loadMaestroPiezas = async (vars, tipo) => {
    setLoadingPiezas(true);
    try {
      const res = await fetch(`/api/vidrieria/maestro-piezas?variables=${vars.join(',')}&tipoProducto=${tipo}`);
      if (res.ok) {
        const data = await res.json();
        setMaestroPiezas(data);

        // Auto-load barcodes for new pieces that are not yet in detalles
        for (const p of data) {
           if (p.CodigoBarra && !getDetalle(p.Variable, p.NombrePieza)) {
              onBarcodeSearch(p.Variable, p.NombrePieza, p.CodigoBarra);
           }
        }
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoadingPiezas(false);
    }
  };

  const getDetalle = (variable, seccion) => {
    return detalles.find(d => {
      try {
        const cfg = typeof d.ConfiguracionJSON === 'string' ? JSON.parse(d.ConfiguracionJSON) : d.ConfiguracionJSON;
        return cfg.variable === variable && cfg.seccion === seccion;
      } catch {
        return false;
      }
    });
  };

  const onSelectProduct = (variable, seccion, product) => {
    let newDetalles = [...detalles];
    const existingIndex = newDetalles.findIndex(d => {
      try {
        const cfg = typeof d.ConfiguracionJSON === 'string' ? JSON.parse(d.ConfiguracionJSON) : d.ConfiguracionJSON;
        return cfg.variable === variable && cfg.seccion === seccion;
      } catch {
        return false;
      }
    });

    if (product) {
      const newD = {
        IdDetalleReceta: Date.now() + Math.random(),
        IdPresentacion: product.value,
        NombrePieza: product.label,
        CodigoBarra: product.codigoBarra,
        ConfiguracionJSON: { variable, seccion, ancho: "", alto: "" }
      };

      if (existingIndex >= 0) {
        const oldCfg = typeof newDetalles[existingIndex].ConfiguracionJSON === 'string'
          ? JSON.parse(newDetalles[existingIndex].ConfiguracionJSON)
          : newDetalles[existingIndex].ConfiguracionJSON;

        newD.ConfiguracionJSON = { ...oldCfg, variable, seccion };
        newDetalles[existingIndex] = newD;
      } else {
        newD.ConfiguracionJSON = { variable, seccion, cantidad: 1 };
        newDetalles.push(newD);
      }
    } else {
      if (existingIndex >= 0) {
        newDetalles.splice(existingIndex, 1);
      }
    }

    onUpdateDetalle(newDetalles);
  };

  const onChangeCantidad = (variable, seccion, newCantidad) => {
    let newDetalles = [...detalles];
    const existingIndex = newDetalles.findIndex(d => {
      try {
        const cfg = typeof d.ConfiguracionJSON === 'string' ? JSON.parse(d.ConfiguracionJSON) : d.ConfiguracionJSON;
        return cfg.variable === variable && cfg.seccion === seccion;
      } catch {
        return false;
      }
    });

    if (existingIndex >= 0) {
      const oldCfg = typeof newDetalles[existingIndex].ConfiguracionJSON === 'string'
        ? JSON.parse(newDetalles[existingIndex].ConfiguracionJSON)
        : newDetalles[existingIndex].ConfiguracionJSON;

      newDetalles[existingIndex].ConfiguracionJSON = { ...oldCfg, cantidad: newCantidad };
      onUpdateDetalle(newDetalles);
    }
  };

  const onBarcodeSearch = async (variable, seccion, barcodeStr) => {
    if (!barcodeStr) return;
    try {
      const results = productosDisponibles.filter(p => p.CodigoProducto && p.CodigoProducto.split(',').some(c => c.trim().toUpperCase() === barcodeStr.toUpperCase())).map(p => ({ value: p.IdPresentacion, label: `${p.Producto} ${p.Presentacion || ""} - S/ ${parseFloat(p.PrecioConIgv || 0).toFixed(2)}`, codigoBarra: p.CodigoProducto }));
      if (results && results.length > 0) {
        // Encontrar coincidencia exacta de codigoBarra o tomar el primero si solo hay 1
        const exactMatch = results.find(r => r.codigoBarra === barcodeStr) || results[0];
        onSelectProduct(variable, seccion, exactMatch);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const renderTable = (titulo, variable, piezas) => {
    let totalPrecio = 0;
    piezas.forEach(pieza => {
      const det = getDetalle(variable, pieza);
      if (det) {
        const cfg = typeof det.ConfiguracionJSON === 'string' ? JSON.parse(det.ConfiguracionJSON) : det.ConfiguracionJSON;
        const cantidad = parseFloat(cfg.cantidad) || 0;
        const productoFull = productosDisponibles.find(p => p.IdPresentacion === det.IdPresentacion);
        if (productoFull && productoFull.PrecioConIgv) {
          totalPrecio += (parseFloat(productoFull.PrecioConIgv) * cantidad);
        }
      }
    });

    return (
      <div className="col-12 col-lg-6 mb-3">
        <div className="card shadow-sm border-0">
          <div className="card-header bg-light py-2 border-bottom">
            <h6 className="m-0 font-weight-bold text-secondary">{titulo}</h6>
          </div>
          <div className="table-responsive">
            <table className="table table-sm table-hover mb-0" style={{ fontSize: '0.8rem' }}>
              <thead className="thead-light">
                <tr>
                  <th style={{ width: '20%' }}>Pieza</th>
                  <th style={{ width: '15%' }}>Código</th>
                  <th style={{ width: '35%' }}>Producto</th>
                  <th style={{ width: '15%' }}>Cant.</th>
                  <th style={{ width: '15%' }}>Total</th>
                </tr>
              </thead>
              <tbody>
                {piezas.map(pieza => {
                  const det = getDetalle(variable, pieza);
                  const maestroObj = maestroPiezas.find(m => m.Variable === variable && m.NombrePieza === pieza);
                  const defaultBarcode = det ? (det.CodigoBarra || "") : (maestroObj ? (maestroObj.CodigoBarra || "") : "");
                  
                  const productValue = det ? { label: det.NombrePieza, value: det.IdPresentacion } : null;
                  const cfg = det ? (typeof det.ConfiguracionJSON === 'string' ? JSON.parse(det.ConfiguracionJSON) : det.ConfiguracionJSON) : {};
                  const cantidad = cfg.cantidad || "";

                  let subtotal = 0;
                  if (det && cantidad) {
                     const productoFull = productosDisponibles.find(p => p.IdPresentacion === det.IdPresentacion);
                     if (productoFull && productoFull.PrecioConIgv) {
                         subtotal = parseFloat(productoFull.PrecioConIgv) * parseFloat(cantidad);
                     }
                  }

                  return (
                    <tr key={pieza}>

                      <td className="align-middle font-weight-bold p-1" style={{ fontSize: '0.75rem' }}>{pieza}</td>
                      <td className="align-middle p-1">
                        <input
                          type="text"
                          className="form-control form-control-sm"
                          style={{ fontSize: '0.8rem', height: '30px' }}
                          placeholder="Código..."
                          defaultValue={defaultBarcode}
                          onBlur={e => onBarcodeSearch(variable, pieza, e.target.value)}
                          onKeyDown={e => {
                            if (e.key === 'Enter') {
                              e.preventDefault();
                              onBarcodeSearch(variable, pieza, e.target.value);
                            }
                          }}
                        />
                      </td>
                      <td className="align-middle p-1">
                        {
                          (()=>{
                            const optionsForSelect = productosDisponibles
                              .filter(p => !defaultBarcode || (p.CodigoProducto && p.CodigoProducto.split(',').some(c => c.trim().toUpperCase() === defaultBarcode.toUpperCase())))
                              .map(p => ({
                                value: p.IdPresentacion,
                                label: `${p.Producto} ${p.Presentacion || ""} - S/ ${parseFloat(p.PrecioConIgv || 0).toFixed(2)}`,
                                codigoBarra: p.CodigoProducto
                              }));
                            
                            return (
                                <Select
                                  placeholder="Buscar..."
                                  isClearable={true}
                                  value={productValue}
                                  onChange={p => onSelectProduct(variable, pieza, p)}
                                  options={optionsForSelect}
                                  menuPortalTarget={document.body}
                                  styles={{
                                    menuPortal: base => ({ ...base, zIndex: 9999, fontSize: '0.8rem' }),
                                    control: base => ({ ...base, minHeight: '30px', height: '30px', fontSize: '0.8rem' }),
                                    valueContainer: base => ({ ...base, padding: '0px 8px' }),
                                    indicatorsContainer: base => ({ ...base, height: '30px' })
                                  }}
                                />
                            );
                          })()
                        }
                      </td>
                      <td className="align-middle p-1">
                        <input
                          type="number"
                          className="form-control form-control-sm text-center"
                          style={{ fontSize: '0.8rem', height: '30px' }}
                          min="1"
                          value={cantidad}
                          onChange={e => onChangeCantidad(variable, pieza, e.target.value)}
                          disabled={!det}
                        />
                      </td>
                      <td className="align-middle p-1 text-center font-weight-bold" style={{ fontSize: '0.8rem' }}>
                        S/ {subtotal.toFixed(2)}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
              <tfoot className="bg-light">
                <tr>
                  <td colSpan="4" className="text-right font-weight-bold p-2 align-middle">TOTAL PRECIO MATERIALES:</td>
                  <td className="font-weight-bold p-2 align-middle text-center" style={{ fontSize: '0.85rem' }}>S/ {totalPrecio.toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
    );
  };

  const piezasW = maestroPiezas.filter(p => p.Variable === 'W').map(p => p.NombrePieza);
  const piezasH = maestroPiezas.filter(p => p.Variable === 'H').map(p => p.NombrePieza);

  return (
    <>
      {loadingPiezas && <div className="text-muted small mb-3">Cargando piezas maestras...</div>}
      <div className="row">
        {hasW && piezasW.length > 0 && renderTable("ANCHO W", "W", piezasW)}
        {hasH && piezasH.length > 0 && renderTable("ALTO H", "H", piezasH)}
      </div>

      {!hasW && !hasH && (
        <div className="alert alert-info">
          Seleccione un Modelo Base que contenga las variables W o H para configurar los insumos.
        </div>
      )}
    </>
  );
}
